// src/Login.js
import React, { useState, useEffect, useContext } from "react"
import { post } from "./../utils/apiClient"
import Cookies from "js-cookie"
import "./../css/login.css" // Import the CSS file for styling
import FormsLogo from "../images/efax.svg"
import { AuthContext } from "../utils/authContext"

const Login = () => {
  const { setAuthUser } = useContext(AuthContext)
  const [username, setUsername] = useState("")
  const [password, setPassword] = useState("")
  const [error, setError] = useState(null)
  const [loading, setLoading] = useState(false) // Track loading state
  const [toggleSSOLogin, setToggleSSOLogin] = useState(false) // Track loading state

  const ssoLookUp = async () => {
    if (!validateEmail(username)) {
      setError("Please enter a valid email address")
      return
    } else {
      setError("")
    }

    try {
      setLoading(true)

      let loginUrl = "/oauth/testLogin"
      if (process.env.REACT_APP_ENV === "production") {
        loginUrl = "/oauth/lookup"
      }

      const data = await post(loginUrl, {
        email: username?.trim(),
      })

      // if (data?.accessToken) {
      //   Cookies.set("auth", JSON.stringify(data), { expires: 1 }) // Store token for 1 days

      //   setAuthUser(data)
      // }

      // Redirect if needed
      if (data?.redirect_url) {
        window.location.href = data.redirect_url
      } else {
        setLoading(false) // Set loading to false when done
      }
    } catch (err) {
      console.log("->  err:", err)
      setError("Invalid user! Please enter correct username.")
      setLoading(false) // Stop loading on error
    }
  }

  const login = async () => {
    if (!username) {
      setError("Please enter a username")
      return
    } else if (!password) {
      setError("Please enter a password")
      return
    } else {
      setError("")
    }

    try {
      setLoading(true)

      let loginUrl = "/validateUser"

      const data = await post(loginUrl, {
        username: username?.trim(),
        password: password?.trim(),
      })

      if (data?.accessToken) {
        Cookies.set("auth", JSON.stringify(data), { expires: 1 }) // Store token for 1 days

        // 2) Update context
        setAuthUser(data)
      }
    } catch (err) {
      console.log("->  err:", err)
      setError("Invalid user! Please enter correct username.")
      setLoading(false) // Stop loading on error
    }
  }

  const handleGo = (e) => {
    e.preventDefault()
    if (toggleSSOLogin) {
      ssoLookUp()
    } else {
      login()
    }
  }

  const validateEmail = (username) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    return emailRegex.test(username)
  }

  useEffect(() => {
    setError("")
    setUsername("")
    setPassword("")
  }, [toggleSSOLogin])

  // Show a loading indicator or error message
  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-message">Loading...</div>
      </div>
    ) // You can customize this loading message
  }

  return (
    <>
      <div className="header-container">
        <div className="logo-container">
          <img src={FormsLogo} height={36} width={200} alt="Consensus Logo" />
        </div>
      </div>
      <div className="login-container">
        <h2>Bulk Fax {toggleSSOLogin ? "| SSO Login" : ""}</h2>
        <form onSubmit={handleGo} className="login-form">
          <div className="form-group">
            <label>{toggleSSOLogin ? "Email" : "Username"}:</label>
            <input
              type="text"
              value={username}
              onChange={(e) => {
                setUsername(e.target.value)
              }}
              className="input-field"
            />
          </div>

          {!toggleSSOLogin && (
            <div className="form-group" style={{ marginTop: "10px" }}>
              <label>Password:</label>
              <input
                type="password"
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value)
                }}
                className="input-field"
              />
            </div>
          )}
          {error && (
            <p
              className="error-message"
              style={{ textAlign: "right", marginTop: "40px" }}
            >
              {error}
            </p>
          )}

          <div className="login-link-container">
            {toggleSSOLogin ? (
              <span className="link" onClick={() => setToggleSSOLogin(false)}>
                Back
              </span>
            ) : (
              <span className="link" onClick={() => setToggleSSOLogin(true)}>
                SSO Login
              </span>
            )}
            <button type="submit" className="login-button">
              Go
            </button>
          </div>
        </form>
      </div>
    </>
  )
}

export default Login
